<template>
  <div class="topNav" :class="classBackground">
    <div class="content color_4B5B76 height_36 " :class="[classWidth, classBackground]">
      <!-- width_auto -->
      <div class="flex_a_c gap_12">
        <div>
          <router-link to="/">
            <div class="flex_a_c gap_3 cur_p">
              <img src="@/assets/images/Icon/HomeOutlined.png" alt="">
              <span>
                有有宝首页
              </span>
            </div>
          </router-link>
        </div>
        <el-divider direction="vertical" />
        <div>
          <!-- 中国 -  -->
          {{ RealCity }}
        </div>
        <el-divider direction="vertical" />
        <div class="user-dropdown">
          <div v-if="!isLogin">
            你好，<span class="backgroundColor_584DFF cur_p" @click="loginBtn">请登录</span> 注册
          </div>
          <div v-else>
            <div class="dropdown_userName color_584DFF_hover cur_p" @mouseenter="showDropdown = true"
              @mouseleave="showDropdown = false" @click="goToUserInfo">
              {{ userInfoData.name }}
              <i class="el-icon-arrow-down"></i>
            </div>
            <!-- 下拉菜单 -->
            <div v-show="showDropdown" class="dropdown-menu" @mouseenter="showDropdown = true"
              @mouseleave="showDropdown = false">
              <div class="menu-item mb_16">
                <div class="menu-item_picture mr_8 cur_p" @click="goToUserInfo">
                  <img :src="userInfoData.headImage || defaultAvatar" alt="">
                </div>
                <div>
                  <p class="fontS_16 color_181818 lh_24">{{ userInfoData.name }}</p>
                  <p class="flex_a_c fontS_14 color_4B5B76 lh_22">
                    <span class="cur_p" @click="loginBtn">切换账号</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="cur_p" @click="outLoginBtn">退出</span>
                  </p>
                </div>
              </div>
              <div>
                <el-button class="btn_white">开通会员享专属权益</el-button>
              </div>
            </div>
            <!-- ----------- -->
          </div>
        </div>
        <el-divider direction="vertical" />
        <div class="cur_p">切换企业版</div>
      </div>
      <div class="right flex_a_c gap_12">
        <div class="color_584DFF_hover" @click="goAIDistribution">
          AI分销
        </div>
        <el-divider direction="vertical" />
        <div class="item item-select">
          <div class="flex_a_c gap_3 cur_p" @click="goToShopCart">
            <!-- <span class="hover-item" @click="goToShopCart"> -->
            <img src="@/assets/images/Icon/ShoppingCartOutlined.png" alt="" />
            购物车
            <span v-if="isShowNum">
              (<b class="color_584dff" v-text="cartNumber === 0 ? '0' : cartNumber"></b>)
            </span>
            <!-- </span> -->
          </div>
          <!-- <div v-if="!isLogin" class="cart-box cart-no-login">
            <a class="loginBtn" @click="loginBtn">登录</a>
            <p class="p">登录后查看商品</p>
          </div> -->
          <!-- <div v-else-if="shoppingCart.length === 0" class="cart-box cart-no-data">
            <img src="static\image\gouwuche_no.webp" alt="">
            <p class="p">购物车还没有商品，赶紧选购吧！</p>
          </div> -->
          <!-- <div v-else class="cart-box cart-list">
            <div class="cartItem" v-for="shop in shoppingCart" :key="shop.shopId">
              <dl v-for="(item, index) in shop.skus" :key="index" v-show="index < 3">
                <dt>
                  <div class="cartImgBox" style="width: 42px;height: 42px;background: #F5F5F5;overflow: hidden;"
                    @click="$router.push('/shopping-trolley')">
                    <img :src="item.image" alt="">
                  </div>
                </dt>
                <dd>
                  <h4 class="h4" @click="$router.push('/shopping-trolley')">{{ item.productName }}</h4>
                  <p>{{ item.SKU }}</p>
                  <span>￥{{ item.price }}</span>
                  <a class="btn-del" @click="deleteCartItem(item)"><i class="el-icon-delete" /></a>
                </dd>
              </dl>
            </div>
            <a class="btn-view-all" @click="goToShopCart" v-if="cartNumber > 3">查看全部</a>
          </div> -->
        </div>

        <el-divider direction="vertical" />
        <div class="cur_p">
          <span class="hover-item" @click="goToUserOrder">我的订单</span>
        </div>
        <el-divider direction="vertical" />
        <div class="flex_a_c gap_3 cur_p">
          <!-- <el-popover placement="top-start" width="176" popper-class="moveYYB" trigger="hover">
            <div>
              <img style="width: 160px;height: 160px; margin-bottom: 4px;" src="@/assets/images/erweima.png" alt="">
              <p class="fontS_14 color_181818 text_c">客户端下载</p>
            </div>
            <div class="color_584DFF_hover" slot="reference">
              客户端
              <i class="el-icon-arrow-down"></i>
            </div>
          </el-popover> -->
          <div class="color_584DFF_hover" @click="toPromotionPage">
            客户端
          </div>
        </div>
        <el-divider direction="vertical" />
        <div class="flex_a_c gap_3 cur_p">
          <el-popover placement="top-start" width="100" popper-class="merchantServices" trigger="hover">
            <div class="merchantServicesBox">
              <p class="color_584DFF_hover" @click="applySettle">合作招商</p>
              <p class="color_584DFF_hover" @click="windowOpen()">商家后台</p>
              <p class="color_584DFF_hover" @click="toKnowledgeRule">平台规则</p>
              <p class="color_584DFF_hover">推广页</p>
            </div>
            <div class="color_584DFF_hover" slot="reference">
              商家服务
              <i class="el-icon-arrow-down"></i>
            </div>
          </el-popover>

        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="outLoginDialog" append-to-body width="30%">
      <span>确定退出登录吗？</span>
      <span slot="footer" class="dialog-footer flex_j_d">
        <el-button @click="outLoginDialog = false">取 消</el-button>
        <el-button type="primary" @click="outLogin">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Cookie from 'js-cookie'
// import { Encrypt } from '@/util/secret'

import {
  getUserInfo,
  getRealCity
} from '@/api/user/user.js'
import {
  getGongGaoAll
} from '@/api/user/notice.js'
import {
  getCartList,
  deleteCartItem,
  clearSelected
} from '@/api/user/cart.js'
import {
  settled, MerchantBackstageUrl
} from '@/api/nav.js'

import defaultAvatar from '@/assets/images/defaultAvatar.png'

export default {
  name: 'siteNav',
  props: {
    componentContent: {
      type: Object
    },
    classWidth: {
      type: String,
      default: 'width_1200'
    },
    classBackground: {
      type: String,
      default: 'background_D6DBE3'
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'shoppingCart',
      'cartNumber'
    ])
  },
  data () {
    return {
      userInfoData: '',
      searchVal: '宝贝',
      keyword: '',
      isShowOut: false,
      menuOpen: false,
      isLogin: false,
      outLoginDialog: false,
      isShowNum: false,
      deleteOpt: {
        visiable: false
      },
      proList: [],
      noticeList: [],
      showDropdown: false, // 控制下拉菜单的显示状态
      defaultAvatar: defaultAvatar,
      RealCity: '中国',
      lastLatitude: '',
      lastLongitude: '',
      // apiKey: '07c788d5f3938997797156b46c1faf71',
      apiKey: '49356e1c6bca4d78ca8631beea01213d',

    }
  },
  watch: {
    '$store.state.isLogin': {
      handler (nVal, oVal) {
        this.isLogin = nVal
        this.isShowNum = nVal
        if (this.isLogin) {
          this.getUserInfoData()
          this.getTrolleyList()
        }
      }
    },
    '$route': {
      handler (to, from) {
        if (to.name === 'index') {
          // 当路由发生变化时，重新获取用户信息和购物车数据
          if (this.isLogin) {
            this.getUserInfoData()
            this.getTrolleyList()
          }
        }
      },
      immediate: true
    }
  },
  created () {
    if (Cookie.get('token')) {
      this.isLogin = true
      this.isShowNum = true
      this.getGongGao()
      this.getUserInfoData()
      this.getTrolleyList()
    }
  },
  mounted () {
    this.getRealCityData()

    // this.getLocationByAMap()
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ',
      setUserInfo: 'SET_USERINFO',
      setCartNumber: 'SET_CARTNUMBER',
      setShoppingCart: 'SET_SHOPPINGCART',
      setNewAddress: 'SET_NEWADDRESS',
      setAreaCode: 'SET_AREACODE',
      setNoticeId: 'SET_NOTICEID',
      IS_LOGIN: 'IS_LOGIN'
    }),
    searchCommand (command) {
      this.searchVal = command
    },
    // 查找
    searchPro () {
      if (!this.keyword) { return this.$message.error('请输入搜索内容') }
      this.setSearchObj({
        keyword: this.keyword,
        searchVal: this.searchVal
      })
      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search'
        })
      }
    },
    // // 获取真实城市信息
    async getRealCityData () {
      if (!navigator.geolocation) {
        // 如果浏览器不支持地理位置，尝试使用IP定位
        await this.getCityByIP()
        return
      }

      const options = {
        timeout: 5000,
        maximumAge: 600000,
        enableHighAccuracy: false
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude
          const longitude = position.coords.longitude
          console.log('获取到位置信息:', latitude, longitude)
          this.getAddressFromCoords(latitude, longitude)
        },
        async (error) => {
          console.error('获取位置失败:', error)
          // 地理位置获取失败时，尝试IP定位
          await this.getCityByIP()
        },
        options
      )
    },

    // 通过IP获取城市信息
    async getCityByIP () {
      try {
        // 使用免费的IP定位服务
        // const response = await fetch('https://ipapi.co/json/')
        // const data = await response.json()
        // console.log('IP定位结果:', data)
        // this.getAddressFromCoords(data.latitude, data.longitude)
        getRealCity().then(res => {
          this.RealCity = res.data.data || '中国'
          localStorage.setItem('userCity', this.RealCity)
          localStorage.setItem('userCityTime', new Date().getTime().toString())
        })
      } catch (error) {
        console.error('IP定位失败:', error)
        this.RealCity = '中国'
      }
    },
    // 如果已有经纬度，可以使用高德地图 API 获取具体地址
    async getAddressFromCoords (lat, lng) {
      // console.log('获取地址信息:', lat, lng)
      // 从localStorage获取上次的位置信息
      const lastLatitude = localStorage.getItem('lastLatitude')
      const lastLongitude = localStorage.getItem('lastLongitude')

      // 判断经纬度是否发生变化（使用数值比较并设置精度）
      const currentLat = parseFloat(lat).toFixed(6)
      const currentLng = parseFloat(lng).toFixed(6)

      if (lastLatitude === currentLat && lastLongitude === currentLng) {
        // 位置未发生变化，使用缓存数据
        const cachedCity = localStorage.getItem('userCity')
        const cachedTime = localStorage.getItem('userCityTime')

        // 检查缓存是否过期（设置缓存有效期为1小时）
        if (cachedCity && cachedTime && (Date.now() - parseInt(cachedTime)) < 3600000) {
          this.RealCity = cachedCity
          // console.log('使用缓存城市信息:', this.RealCity)
          return
        }
      }

      // 位置发生变化或缓存过期，重新获取城市信息
      // const url = `https://restapi.amap.com/v3/geocode/regeo?output=json&location=${lng},${lat}&key=${this.apiKey}`
      const url = `https://api.tianditu.gov.cn/geocoder?postStr={'lon':${lng},'lat':${lat},'ver':1}&type=geocode&tk=${this.apiKey}`
      try {
        const response = await fetch(url)
        const data = await response.json()
        // console.log('获取城市信息:', data)
        if (data.status === '0') {
          // const address = data.regeocode.addressComponent
          // // 手动拼接，确保不会有连续的连接符
          // let result = ''
          // // 添加省份
          // if (address.province && address.province.trim()) {
          //   result += address.province.trim()
          // }
          // // 添加城市（避免与省份重复）
          // let cityValue = ''
          // if (Array.isArray(address.city)) {
          //   // 如果是数组，取第一个元素
          //   cityValue = address.city[0] || ''
          // } else {
          //   // 如果是字符串，直接使用
          //   cityValue = address.city || ''
          // }
          // if (cityValue && cityValue.trim() && cityValue.trim() !== address.province) {
          //   result += (result ? '-' : '') + cityValue.trim()
          // }
          // // 添加区域
          // if (address.district && address.district.trim()) {
          //   result += (result ? '-' : '') + address.district.trim()
          // }
          // this.RealCity = result || '中国'
          this.RealCity = data.result.addressComponent.province + '-' + data.result.addressComponent.county || '中国'

          // 更新缓存中的位置信息
          localStorage.setItem('lastLatitude', currentLat)
          localStorage.setItem('lastLongitude', currentLng)
          // 缓存城市信息
          localStorage.setItem('userCity', this.RealCity)
          localStorage.setItem('userCityTime', new Date().getTime().toString())
          // console.log('更新城市信息:', this.RealCity)
        }
      } catch (error) {
        console.error('解析地址失败:', error)
        this.RealCity = '中国'
      }
    },
    // 个人信息
    async getUserInfoData () {
      const response = await getUserInfo()
      const res = response.data
      if (res.code === '200') {
        this.setUserInfo(res.data)
        this.userInfoData = res.data
      } else {
        this.$message.error('获取个人信息失败！')
      }
    },
    // 购物车列表
    async getTrolleyList () {
      const response = await getCartList()
      const res = response.data
      let cartNumber = 0
      if (res.data && res.data.length) {
        res.data.forEach(j => {
          cartNumber = cartNumber + j.skus.length
        })
      }
      this.setShoppingCart(res.data)
      this.setCartNumber(cartNumber)
    },
    // 公告
    async getGongGao () {
      const response = await getGongGaoAll()
      const res = response.data
      if (res.code === '200') {
        this.noticeList = res.data
      } else {
        this.$message.warning(res.message)
      }
    },
    // 删除单个商品
    async deleteCartItem (item) {
      let ids = []
      ids.push(item.skuId)
      await deleteCartItem({ ids })
      let id = item.skuId
      this.shoppingCart.map(j => {
        j.skus.map(k => {
          if (k.skuId === id) {
            j.skus.splice(j.skus.findIndex(item => item.skuId === id), 1)
          }
        })
      })
      this.setCartNumber(this.cartNumber - 1)
      this.getTrolleyList()
      this.$message.success('删除成功')
    },
    outLoginBtn () {
      this.outLoginDialog = true
    },
    // 跳转登录页面
    goLogin () {
    },
    outLogin () {
      this.outLoginDialog = false
      Cookie.remove('token')
      this.setUserInfo({})
      this.setCartNumber('')
      this.setShoppingCart({})
      this.setNewAddress({})
      this.setAreaCode([])
      // this.$router.push({path: '/login', query: {type: 2}})
      this.$router.push({ path: '/index' })
      this.$store.commit('IS_LOGIN', false) // 清除登录状态
      this.isLogin = false
      this.isShowNum = false
    },
    // 跳转推广页
    toPromotionPage () {
      this.$router.push({ path: '/PromotionPage' })
    },
    toKnowledgeRule () {
      this.$router.push({ path: '/knowledgeRule' })
    },
    // 申请入驻
    applySettle () {
      // let token
      // if (Cookie.get('token')) {
        // token = Encrypt(Cookie.get('token'))
        // let username = encodeURI(this.userInfo.name)
        // let userInfo = encodeURI(username)
        // let test = Decrypt(token)
        window.open(`${settled}`)
        // window.open(`${settled}?username=${userInfo}&user=${token}`)
      // } else {
      //   this.$store.commit('SHOW_LOGIN')
      // }
    },
    goToUserInfo () {
      if (Cookie.get('token')) {
        this.$router.push({ path: '/userHome' })
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    goToUserOrder () {
      if (Cookie.get('token')) {
        this.$router.push({ path: '/myOrder' })
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    goToAfterOrder () {
      if (Cookie.get('token')) {
        this.$router.push({ path: '/orderAfterSale' })
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    loginBtn (type) {
      this.$store.commit('SHOW_LOGIN')
      // this.$router.push({path: '/login', query: {type: type}})
    },
    goToUserAddress () {
      if (Cookie.get('token')) {
        this.$router.push({ path: '/signingAddress' })
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    gotoUserCoupon () {
      if (Cookie.get('token')) {
        this.$router.push({ path: '/couponPackage' })
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    async goToShopCart () {
      if (Cookie.get('token')) {
        await clearSelected()
        this.$router.push({ path: '/shopping-trolley' })
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    // AI分销
    goAIDistribution () {
      if (Cookie.get('token')) {
        this.$router.push({ path: '/myDistribution' })
      } else {
        this.$store.commit('SHOW_LOGIN')
      }
    },
    hover () {
      this.isShowOut = true
    },
    // 跳转到公告详情
    goToDetail (id) {
      this.$router.push({
        path: '/activity/notificationDetails',
        query: {
          id: id
        }
      })
      this.setNoticeId(id)
    },
    // 跳转商家端
    windowOpen () {
      window.open(`${MerchantBackstageUrl}`)
    },
  }
}
</script>

<style lang="scss" scoped>
$lightBlack: #666666;
$navSearchHeight: 39px;

.topNav {
  font-size: 12px;
  color: #161A1E;
  width: 100%;
  position: sticky;
  top: 0px;
  z-index: 9999;

  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .search {
      width: 430px;
      max-width: 100%;
      height: $navSearchHeight;
      margin: 5px;
      border: 1px solid $lightBlack;
      border-radius: 0px;
      overflow: hidden;
      position: relative;
      display: flex;

      .searchSelect {
        margin: 10px 10px 10px 0;
        padding: 0 12px;
        border-right: 1px solid #E5E5E5;

        >>>.el-dropdown-link {
          font-size: 16px;
          color: #fff;
        }
      }

      .searchRight {
        flex: 1;

        input {
          width: 100%;
          height: $navSearchHeight;
          color: #CCCCCC;
          padding: 0 60px 0 15px;
          font-size: 14px;
          box-sizing: border-box;
          background-color: $lightBlack;
        }
      }

      .btn {
        width: 25px;
        height: 100%;
        padding-right: 12px;
        background-color: $lightBlack;
        color: #fff;
        line-height: $navSearchHeight;
        text-align: center;
        cursor: pointer;
      }
    }

    .indexPage {
      .svg-icon {
        margin-left: 12px;
        font-size: 40px;
        cursor: pointer;
      }

      img {
        width: 50px;
        height: 42px;
      }
    }

    .right {
      .item {
        display: inline-block;

        // color: #FFFFFF;
        // line-height: 36px;
        .iconfont {
          font-size: 12px;
        }

        span {
          cursor: pointer;

          b {
            color: $mainGlod;
            padding: 0 2px;
          }
        }

        .iconfont {
          margin-right: 5px;
        }

        &.item-select {
          position: relative;
        }

        &:hover {
          // background-color: #fff;

          .cart-no-data,
          .cart-no-login {
            display: flex;
          }

          .cart-list,
          .user-box {
            display: block;
          }

          .hover-item {
            color: $mainGlod;
          }
        }
      }
    }

    .cart-box {
      position: absolute;
      top: 35px;
      // top: 100%;
      background-color: #fff;
      z-index: 999;
      border-radius: 5px;
      box-shadow: 0px 0px 24px 3px rgba(0, 0, 0, 0.06);

      .cartImgBox {
        img {
          width: 100%;
        }
      }

      &.cart-no-login {
        min-width: 200px;
        left: -100px;
        height: 160px;
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .btn {
          display: inline-block;
          padding: 0 15px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          color: #fff;
          background-color: $mainColor;
          border-radius: 4px;
          margin-bottom: 40px;
        }

        .p {
          color: #666666;
          line-height: 1em;
        }
      }

      &.cart-no-data {
        width: 264px;
        height: 110px;
        left: 50%;
        margin-left: -132px;
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #666;
      }

      &.cart-list {
        width: 348px;
        left: 50%;
        margin-left: -174px;
        display: none;
        padding: 10px;

        .cartItem {
          border-bottom: 1px solid #F5F5F5;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        dl {
          flex: 1;
          width: 100%;
          height: 70px;
          margin: 5px 0;

          dt {
            float: left;
            cursor: pointer;
          }

          dd {
            margin-left: 54px;
            position: relative;
            padding-right: 60px;
            min-height: 42px;
            line-height: 21px;

            h4 {
              color: #333;
              cursor: pointer;
              font-size: 14px;
              @include ellipsis;
            }

            p {
              color: #333;
              font-size: 14px;
              @include ellipsis;
            }

            span {
              color: #C83732;
              position: absolute;
              top: 0;
              right: 0;
              font-size: 14px;
            }

            .btn-del {
              color: #333;
              position: absolute;
              top: 20px;
              right: 0;
              font-size: 14px;
            }
          }
        }

        .btn-view-all {
          display: block;
          margin: auto;
          // float: right;
          padding: 0 15px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          color: #fff;
          background-color: $mainGlod;
          border-radius: 4px;
          margin-top: 10px;
          cursor: pointer;
        }
      }

      &.user-box {
        width: 400px;
        top: 35px;
        left: -315px;
        // padding: 18px 0;
        display: none;

        .info {
          display: flex;
          margin: 15px;
          height: 60px;

          .avatar {
            background-color: #666666;
            cursor: pointer;

            img {
              width: 54px;
              height: 54px;
            }
          }

          .vip {
            margin-left: 10px;
            flex: 1;
            cursor: default;

            .top {
              height: 35px;
              display: flex;
              justify-content: space-between;

              .level {
                display: block;
                width: 86px;
                height: 22px;
                color: $mainGlod;
                position: relative;
                top: -15px;
              }

              .logout {
                width: 115px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 14px;
                font-family: Microsoft YaHei;
                color: #fff;
                background: $violetColor;
                box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.16);
                border-radius: 3px;
                cursor: pointer;
              }
            }

            .bottom {
              p {
                font-size: 12px;
                line-height: 16px;
                color: #999999;

                span {
                  color: $mainGlod;
                }
              }
            }
          }
        }

        .personal {
          display: flex;
          justify-content: space-around;

          li {
            flex: 1;
            font-size: 16px;
            padding-top: 12px;
            cursor: pointer;
            color: #333;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &:hover {
              color: $mainGlod;
              background-color: #F5F5F5;
            }
          }
        }
      }
    }
  }

  .loginBtn {
    width: 115px;
    margin: 15px auto;
    line-height: 30px;
    text-align: center;
    color: #fff;
    background: $violetColor;
    border: 1px solid $violetColor;
    cursor: pointer;

    &:hover {
      background: #FFFFFF;
      color: $violetColor;
      border-color: $violetColor;
    }
  }

  .user-dropdown {
    position: relative;
    display: inline-block;

    .dropdown-menu {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1000;
      width: 232px;
      height: 134px;
      background: #FFFFFF;
      box-shadow: 0px 12px 48px 16px rgba(31, 31, 31, 0.03), 0px 9px 28px 0px rgba(0, 0, 0, 0.03), 0px 6px 16px -8px rgba(0, 0, 0, 0.08);
      border-radius: 6px 6px 6px 6px;
      animation: fadeIn 0.2s ease-in-out;
      padding: 16px;

      .menu-item {
        display: flex;
        align-items: center;
        height: 46px;

        .menu-item_picture {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;     }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/topNav.vue